import { useContext, useEffect, useState } from "react";
import { AppContext } from "../app-context";

interface FetchResponse extends Response {
  parsedBody?: google.maps.GeocoderResponse
}

export const useGeolocation = () => {

  const {secretBaseUrl} = useContext(AppContext);
  const [apiKey, setApiKey] = useState<string | null>(null);

  useEffect(() => {
    if (secretBaseUrl) {
      fetch(`${secretBaseUrl}/google`).then(res => {
        return res.json()
      }).then(body => {
        setApiKey((body as any)?.apiKey);
      });
    }
  }, [secretBaseUrl]);

  const getLocation = (lat: number, lng: number): Promise<FetchResponse> => {
    return new Promise((resolve, reject) => {
      let response: FetchResponse;
      const endpoint = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;
      fetch(endpoint)
        .then(res => {
          response = res;
          return res.json();
        })
        .then(body => {
          if (response.ok) {
            response.parsedBody = body;
            resolve(response);
          } else {
            reject(response);
          }
        }).catch(err => {
            reject(err);
        });
    });
  };

  return getLocation;

}
